import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
  protected override _createContainer(): void {
    super._createContainer();

    const container = this._containerElement;

    container.removeAttribute('popover');

    const observer = new MutationObserver(() => {
      container.querySelectorAll('.cdk-global-overlay-wrapper[popover]').forEach((el) => {
        el.removeAttribute('popover');
      });
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    container.style.position = 'fixed';
    container.style.inset = '0';
    container.style.zIndex = '1000';

    container.classList.add('cdk-no-top-layer');

    if (container.parentElement !== document.body) {
      document.body.appendChild(container);
    }
  }
}
